import { AGENT_META, AgentCapability, AgentId } from "@/constants/agents";
import { ConnectAgentButton } from "./ConnectAgentButton";

/**
 * The content of an agent row and a model row. Shared by the composer's "Where this chat runs" and
 * model menus and the rail footer's default menu, which wrap them in their own row register, so
 * none of them can drift on what an agent looks like or says.
 */

/** Mark, name, the connected account or the plan it runs on, and Connect until it is connected. */
export function AgentRowLabel({
  agent,
  capability,
  onConnect,
}: {
  agent: AgentId;
  capability: AgentCapability;
  onConnect: () => void;
}) {
  const { Logo, label, menuSubline } = AGENT_META[agent];
  return (
    <>
      <Logo className="size-4 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="truncate">{label}</div>
        <div className="truncate text-xs leading-snug text-muted-foreground">
          {capability.connected && capability.account_email
            ? capability.account_email
            : menuSubline}
        </div>
      </div>
      {!capability.connected && <ConnectAgentButton onClick={onConnect} />}
    </>
  );
}

/** An alias's name over its tagline, or a model's label alone. */
export function ModelRowLabel({
  label,
  description,
}: {
  label: string;
  description?: string;
}) {
  return (
    <div className="flex-1 min-w-0">
      <div className="truncate">{label}</div>
      {description && (
        <div className="text-xs leading-snug text-muted-foreground">
          {description}
        </div>
      )}
    </div>
  );
}
